import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  CircularProgress,
  Divider,
  Chip,
} from '@mui/material';
import { useAppSelector } from '../../store/hooks';

interface ViewRelationshipModalProps {
  open: boolean;
  onClose: () => void;
}

const ViewRelationshipModal: React.FC<ViewRelationshipModalProps> = ({ open, onClose }) => {
  const { selectedRelationship, loading } = useAppSelector((state) => state.relationships);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Detalle de la Relación</DialogTitle>
      <DialogContent>
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
            <CircularProgress />
          </Box>
        ) : selectedRelationship ? (
          <Box sx={{ mt: 2 }}>
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Tabla Destino
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedRelationship.targetTable
                  ? `${selectedRelationship.targetTable.schemaName}.${selectedRelationship.targetTable.tableName}`
                  : selectedRelationship.targetTableId}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Tipo de Relación
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedRelationship.relationshipType}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Condición de Join
              </Typography>
              <Typography variant="body1" sx={{ mb: 2, fontFamily: 'monospace', fontSize: '0.9rem' }}>
                {selectedRelationship.joinCondition}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Descripción
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedRelationship.description}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Contexto de Negocio
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedRelationship.businessContext}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Es Identificante
              </Typography>
              <Chip
                label={selectedRelationship.isIdentifying ? 'Sí' : 'No'}
                color={selectedRelationship.isIdentifying ? 'primary' : 'default'}
                size="small"
              />
              <Divider sx={{ mt: 2 }} />
            </Box>

            {selectedRelationship.targetTable && (
              <>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle2" color="text.secondary">
                    Descripción de Tabla Destino
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    {selectedRelationship.targetTable.description}
                  </Typography>
                  <Divider />
                </Box>

                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle2" color="text.secondary">
                    Columnas PK (Tabla Destino)
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    {selectedRelationship.targetTable.primaryKeyColumns.join(', ')}
                  </Typography>
                  <Divider />
                </Box>

                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle2" color="text.secondary">
                    Palabras Clave (Tabla Destino)
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    {selectedRelationship.targetTable.keywords.join(', ')}
                  </Typography>
                  <Divider />
                </Box>
              </>
            )}

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Fecha de Creación
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedRelationship.createdAt}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Fecha de Actualización
              </Typography>
              <Typography variant="body1">
                {selectedRelationship.updatedAt}
              </Typography>
            </Box>
          </Box>
        ) : (
          <Typography>No hay relación seleccionada</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewRelationshipModal;
